import request from '@/utils/request'

// 查询发票信息列表
export function listInvoice(query) {
  return request({
    url: '/fina/invoice/list',
    method: 'get',
    params: query
  })
}

// 查询发票信息详细
export function getInvoice(invoiceId) {
  return request({
    url: '/fina/invoice/' + invoiceId,
    method: 'get'
  })
}

// 新增发票信息
export function addInvoice(data) {
  return request({
    url: '/fina/invoice',
    method: 'post',
    data: data
  })
}

// 修改发票信息
export function updateInvoice(data) {
  return request({
    url: '/fina/invoice',
    method: 'put',
    data: data
  })
}

// 删除发票信息
export function delInvoice(invoiceId) {
  return request({
    url: '/fina/invoice/' + invoiceId,
    method: 'delete'
  })
}

// 导出发票信息
export function exportInvoice(query) {
  return request({
    url: '/fina/invoice/export',
    method: 'get',
    params: query
  })
}

// 查询日记账明细list
export function getMobileList(query) {
  return request({
    url: '/fina/dayBookDetailed/mobileList',
    method: 'get',
    params: query
  })
}
// 查询日记账明细详细
export function getDayBookDetailed(daybookDetailedId) {
  return request({
    url: '/fina/dayBookDetailed/' + daybookDetailedId,
    method: 'get'
  })
}
// 修改日记账明细
export function updateDetailed(data) {
  return request({
    url: '/fina/dayBookDetailed/updateClaimStatus',
    method: 'post',
    data: data
  })
}